import { render, staticRenderFns } from "./DoneActivityDialog.vue?vue&type=template&id=54a10606&scoped=true"
import script from "./DoneActivityDialog.vue?vue&type=script&lang=ts"
export * from "./DoneActivityDialog.vue?vue&type=script&lang=ts"
import style0 from "./DoneActivityDialog.vue?vue&type=style&index=0&id=54a10606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a10606",
  null
  
)

export default component.exports